import {all} from 'redux-saga/effects'

import requestApi from './requestApi/saga'
import dataSource from './dataSource/saga'

export default function* rootSaga() {
  yield all([requestApi(), dataSource()])
}
